import * as color from './color';
import * as common from './common';
import * as image from './image';

const renderCommonMap: any = {
  ...common,
  ...color,
  ...image,
};

export { renderCommonMap };
